import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/bj.jpg';
const _hoisted_1 = {
  class: "box"
};
import Header from "@/views/header/index.vue";
import Main from "@/views/mian/index.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "bg",
        src: _imports_0,
        alt: ""
      }, null, -1)), _createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_header, null, {
          default: _withCtx(() => [_createVNode(Header)]),
          _: 1
        }), _createVNode(_component_el_main, {
          class: "main"
        }, {
          default: _withCtx(() => [_createVNode(Main)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});